import * as R from 'ramda';
import { createLogic } from 'redux-logic';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature fleet-profile-simple
import { setInitialState } from './actions';
//////////////////////////////////////////////////

const locationChangeLogic = createLogic({
  type: GC.LOCATION_CHANGE_ACTION,
  validate({ action }, allow) {
    allow(action);
  },
  process({ getState }, dispatch, done) {
    const { fleetProfileSimple } = getState();

    const { truckProfile, trailerProfile, openedDriverProfile } = R.or(fleetProfileSimple, {});

    if (G.isAnyTrue(openedDriverProfile, truckProfile.opened, trailerProfile.opened)) {
      dispatch(setInitialState());
    }

    done();
  },
});

export default [locationChangeLogic];
